import React from 'react'
import { fetchOtp } from "../Service/AllProductionAPI";
import { useState, useEffect } from "react";
import Toast from 'react-bootstrap/Toast';
const OtpNavbarComp = () => {
 const [otp, setOtp] = useState(null); 
   const [showToast, setShowToast] = useState(true);

    // useEffect(() => {
    //     const fetchOtpFromApi = async () => {
    //       const token = sessionStorage.getItem("token");
    //       const fkUserId = sessionStorage.getItem("pkUserId"); 
    
    //       if (fkUserId) {
    //         try {
    //           const fetchedOtp = await fetchOtp(fkUserId, token); 
    //           // console.error("navabr Fetech api otp....................", fetchedOtp);
    //           if (fetchedOtp) {
    //             setOtp(fetchedOtp); 
    //           }
    //         } catch (error) {
    //           console.error("Error during OTP fetch:", error);
    //         }
    //       } else {
    //         console.error("No fkUserId found in sessionStorage.");
    //       }
    //     };
    
    //     fetchOtpFromApi(); 
    //   }, []); 

    useEffect(() => {
      const intervalId = setInterval(async () => {
        const token = sessionStorage.getItem("token");
        const fkUserId = sessionStorage.getItem("pkUserId");
  
        if (fkUserId && token) {
          try {
         
            const fetchedOtp = await fetchOtp(fkUserId, token);
            console.log("Navbar Fetch OTP API:", fetchedOtp);
            setOtp(fetchedOtp);
          } catch (error) {
            console.error("Error during OTP fetch:", error);
          } finally {
           
          }
        } else {
          console.error("No fkUserId or token found in sessionStorage.");
        }
      }, 4000); 

      return () => clearInterval(intervalId);
    }, []);
    
  return (
    <div>  
       {otp?.template && showToast ? (
  <Toast
  onClose={() => setShowToast(false)}
  show={showToast}
  delay={1004456646400} 
  autohide
  style={{
    position: 'absolute',
    right: '320px',
    top: '150px',
    marginBottom: '20px',
    zIndex: '10000',
    backgroundColor: '#007bff',
    color: 'white',
  }}
>
  <Toast.Header>
    <img
      src="holder.js/20x20?text=%20"
      className="rounded me-2"
      alt=""
    />
    <strong className="me-auto text-black">OTP Notification</strong>
  </Toast.Header>
  <Toast.Body>{otp.template}</Toast.Body>
</Toast>
 ) : null}  
    </div>
  )
}

export default OtpNavbarComp





// // all fetch otp and delete otp
// import React, { useState, useEffect } from 'react';
// import { fetchOtp, deleteOtp } from "../Service/AllProductionAPI";

// const OtpNavbarComp = () => {
//   const [otpData, setOtpData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const token = sessionStorage.getItem("token");
//   const fkUserId = sessionStorage.getItem("pkUserId");

//   const fetchOtpFromApi = async () => {
//     if (!fkUserId || !token) {
//       console.error("Missing fkUserId or token in sessionStorage.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const fetchedData = await fetchOtp(fkUserId, token);
//       console.log("Fetched OTP Data (Navbar):", fetchedData);

//       if (fetchedData?.otp) {
//         setOtpData(fetchedData);
//       } else {
//         setOtpData(null);
//         console.warn("No OTP data found.");
//       }
//     } catch (error) {
//       console.error("Error fetching OTP:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteOtp = async () => {
//     if (!otpData?.pkFieldotpId) {
//       console.error("OTP ID not found.");
//       return;
//     }

//     const confirmDelete = window.confirm("Are you sure you want to delete this OTP?");
//     if (!confirmDelete) return;

//     try {
//       setLoading(true);
//       const result = await deleteOtp(otpData.pkFieldotpId);

//       if (result.success) {
//         alert("OTP deleted successfully.");
//         setOtpData(null); // Remove from UI
//       } else {
//         alert("Failed to delete OTP.");
//       }
//     } catch (error) {
//       console.error("Error deleting OTP:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOtpFromApi();
//   }, []);

//   return (
//     <div className="otp-container" style={{ padding: "1rem", border: "1px solid #ccc", borderRadius: "8px", marginBottom: "1rem" }}>
   

//       {loading && <p>Loading...</p>}

//       {!loading && otpData ? (
//         <div>
//           <p><strong>OTP:</strong> {otpData.otp}</p>
        
 
//           <p><strong>Template:</strong> {otpData.template}</p>
    
//           <p><strong>OTP ID:</strong> {otpData.pkFieldotpId}</p>
       

//           <button onClick={handleDeleteOtp} style={{ marginTop: "1rem", backgroundColor: "red", color: "white", padding: "0.5rem 1rem", border: "none", borderRadius: "4px" }}>
//             Delete OTP
//           </button>
//         </div>
//       ) : (
//         !loading && <p>No OTP found</p>
//       )}
//     </div>
//   );
// };

// export default OtpNavbarComp;


